export const AA = 'aa';
export const AA_SAAS = 'aa-saas';
export const AA2 = 'aa2';
// export const AA2_SAAS = 'aa2-saas';
export const AME = 'ame';
export const AM_SAAS = 'am-saas';
export const SDK = 'sdk';
export const SDK_IOS = 'sdk-ios';
export const SDK_ANDROID = 'sdk-android';
export const AS = 'as';
export const AS_SAAS = 'as-saas';

const logoImagePath = '/assets/images/logos/';

export const products = {
  ame: {
    code: AME,
    name:
      'ActiveMerchant',
    imgDashboard:
      `${logoImagePath}AM_logo_less_height.png`,
    imgNoBorder: `${logoImagePath}AM_logo_no_border.png`,
    imgLogo: `${logoImagePath}AM_logo_only.png`,
    imgStyle: {height: '40%', width: '40%'},
    subHeading:
      '3D Secure 1 Merchant Plug-In (MPI)',
    description:
    'Designed for large merchants, payment service providers and acquirers to provide 3D Secure 1 card-not-present authentication '
    + 'for the Verified by Visa, Mastercard SecureCode, JCB J/Secure, American Express SafeKey and Diners Club International ProtectBuy authentication standards.',
    description2:
      'ActiveMerchant enterprise runs in a standalone web server offering both a redirection and API implementation model, is scalable across multiple servers and utilises most relational databases for secure data storage.',
    path:
      '/releases/ame/latest',
    available: true
  },
  aa: {
    code: AA,
    name:
      'ActiveAccess',
    imgDashboard:
      `${logoImagePath}AA_logo_less_height.png`,
    imgNoBorder: `${logoImagePath}AA_logo_no_border.png`,
    imgLogo: `${logoImagePath}AA_logo_only.png`,
    imgStyle: {height: '35%', width: '35%'},
    subHeading:
      '3D Secure 1 and 2 Access Control Server (ACS)',
    description:
      'ActiveAccess incorporates a high-performance and scalable authentication server, a role-based administration management server with a centralised, web-based interface, and enrolment and registration servers for management of cardholder accounts. The system supports single and multiple issuers.',
    description2:
      'The ActiveAccess multi-factor authentication platform is a fully featured, bank-grade application designed for card issuers, enterprises, government and third party application service providers.',
    path: '/docs/aa',
    available: true,
    nested: [
      {
        name: '11X',
        children: [
          {
            name: 'Documentation',
            permissionRequired: false,
            path: '/docs/aa'
          },
          {
            name: 'Download',
            permissionRequired: true,
            path: '/releases/aa/latest'
          }
        ]
      },
      {
        name: '20X',
        children: [
          {
            name: 'Documentation',
            permissionRequired: false,
            path: '/docs/aa2'
          },
          {
            name: 'Download',
            permissionRequired: true,
            path: '/releases/aa2/latest'
          }
        ]
      }
    ]

  },
  aa2: {
    code: AA2,
    name: 'ActiveAccess 20X',
    imgDashboard: `${logoImagePath}AA_logo_less_height.png`,   // TODO: update to 20X image
    imgNoBorder: `${logoImagePath}AA_logo_no_border.png`,   // TODO: update to 20X image
    imgLogo: `${logoImagePath}AA_logo_only.png`,   // TODO: update to 20X image
    imgStyle: {height: '35%', width: '35%'},
    subHeading:
      '3D Secure 1 and 2 Access Control Server (ACS)',
    description:
      'ActiveAccess 20X incorporates a high-performance and scalable authentication server, a role-based administration management server with a centralised, web-based interface, and enrolment and registration servers for management of cardholder accounts. The system supports single and multiple issuers.',
    description2:
      'The ActiveAccess 20X multi-factor authentication platform is a fully featured, bank-grade application designed for card issuers, enterprises, government and third party application service providers.',
    path: '/docs/aa2',
    available: false,
  },
  as: {
    code: AS,
    name:
      'ActiveServer',
    imgDashboard:
      `${logoImagePath}AS_logo_less_height.png`,
    imgNoBorder: `${logoImagePath}AS_logo_no_border.png`,
    imgLogo: `${logoImagePath}AS_logo_only.png`,
    subHeading:
      '3D Secure 2 3DS Server (3DSS)',
    description:
      'Updated merchant side component for 3DS2, which has been expanded to cover the new mobile, frictionless (risk-based) and non-payment authentication process introduced in 3DS2 while still providing the core merchant liability shift 3DS offers.',
    description2:
      'ActiveServer leverages the latest improvements from the EMVCo 3DS2 protocol (such as risk-based, multi-factor and non-payment authentication, biometrics) to give merchants greater security and flexibility during eCommerce transactions.',
    description3: "3DS2 has introduced a brand new merchant side\n" +
      "component, 3DS Server. GPayments ActiveServer is designed to comply with the latest protocol updates\n" +
      "to provide merchants with the latest improvements such as native support for mobile application and\n" +
      "frictionless authentication flow.",
    path: '/myapps/3ds-server',
    available: true,
    nested: [
      {
        name: 'My Instances',
        permissionRequired: true,
        path: '/myapps/3ds-server'
      },
      {
        name: 'SaaS',
        permissionRequired: true,
        path: '/saas/uptime'
      },
      {
        name: 'Documentation',
        permissionRequired: false,
        path: '/docs/as'
      },
      {
        name: 'Download',
        permissionRequired: true,
        path: '/releases/as/latest'
      }
    ]

  },
  sdk: {
    code: SDK,
    name:
      'ActiveSDK',
    imgDashboard:
      `${logoImagePath}SDK_logo_less_height.png`,
    imgNoBorder: `${logoImagePath}SDK_logo_no_border.png`,
    imgLogo: `${logoImagePath}SDK_logo_only.png`,
    subHeading:
      '3D Secure 2 3DS Software Development Kit (SDK)',
    description:
      'Newly introduced component for 3DS2, Android and iOS mobile SDK\'s to allow merchants to offer 3DS2 authentication for their customers natively via merchant apps.',
    description2:
      'ActiveSDK allows merchants to support the rise of eCommerce by natively supporting 3DS2 in mobile apps, offering a seamless and secure cardholder experience while facilitating the rich data exchange required for risk-based authentication.',
    description3: "3DS2 brings native mobile support to merchant applications with the " +
      "              introduction of the 3DS SDK. GPayments' ActiveSDK supports both the Android and iOS ecosystems and\n" +
      "              enables\n" +
      "              rich data collection from card holder devices to make frictionless authentication possible.",
    path:
      '/myapps/sdk',
    available:
      false
  },
};

const isOtherSentinel = v => v != null && v.version === 'other';
const hasVersion = v => v != null && typeof v.version === 'string';

/**
 * ActiveAccess 11X and 20X share a single backend product/bucket (`aa`) and a single
 * permission (`aa`). They are only distinguished by the release version string:
 * a version matching /^11\./ (plus the shared 'other' sentinel) is 11X; every other
 * real version is 20X.
 *
 * A "release channel" keeps 11X (`aa`) and 20X (`aa2`) as separate frontend keys
 * (routes, menu, redux state) while translating to the real backend product and
 * filtering the returned versions. Use `releaseBackend`/`releaseFilter` at every
 * point where a frontend key would otherwise hit the release API.
 *
 * The `/{product}/versions` payload carries a sentinel entry whose version is the
 * literal string 'other' (a shared supporting-docs bundle, consumed in
 * reducers/releases.js and DownloadList.js). It must stay in the 11X channel
 * (dropping it removes the live "Other Downloads" section) and must NOT leak into
 * 20X (it is 11X content) — hence `isOtherSentinel`. `hasVersion` guards the shape
 * so a malformed entry without a string `version` cannot throw inside .filter().
 */
export const releaseChannels = {
  // 11X: versions like 11.x, plus the shared 'other' supporting-docs sentinel.
  [AA]: {backend: AA, match: v => isOtherSentinel(v) || (hasVersion(v) && /^11\./.test(v.version))},
  // 20X: acs-core uses 0.x versioning (e.g. 0.5.0.8), so 20X is "any real
  // version that is not 11X". Do NOT switch this to /^20\./ — 20X releases are
  // 0.x, not 20.x, and would vanish from the channel. The 'other' sentinel is
  // 11X content and is excluded here.
  [AA2]: {backend: AA, match: v => hasVersion(v) && !isOtherSentinel(v) && !/^11\./.test(v.version)},
};

export const releaseBackend = key => (releaseChannels[key] ? releaseChannels[key].backend : key);

export const releaseFilter = key => (releaseChannels[key] ? releaseChannels[key].match : () => true);
